import { BottomSheet, BottomSheetIllustrationContent } from "@clipboard-health/ui-components";
import { type UseModalState } from "@clipboard-health/ui-components";
import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { useHistory } from "react-router-dom";

interface AddLicenseAlertBottomSheetProps {
  modalState: UseModalState;
}

export function AddLicenseAlertBottomSheet(props: AddLicenseAlertBottomSheetProps) {
  const { modalState } = props;
  const history = useHistory();

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" sx={{ marginTop: 5, marginBottom: 5 }}>
          <Button
            fullWidth
            variant="outlined"
            size="large"
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.ADD_LICENSE_ALERT_BOTTOM_SHEET_NOT_NOW_BUTTON_CLICKED);
              modalState.closeModal();
            }}
          >
            Not now
          </Button>
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => {
              logEvent(
                APP_V2_USER_EVENTS.ADD_LICENSE_ALERT_BOTTOM_SHEET_ADD_LICENSE_BUTTON_CLICKED
              );
              modalState.closeModal();
              history.push(DeprecatedGlobalAppV1Paths.ADD_LICENSE);
            }}
          >
            Add a License
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="info"
        title="Add a License"
        description="You can't see any shifts because you don't have any active licenses. Would you like to add one now and start looking for shifts?"
      />
    </BottomSheet>
  );
}
